import { initializeApp, getApps, deleteApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);

// App secondaire : permet de créer un compte Auth (pour un agent) sans
// déconnecter l'utilisateur courant. À libérer avec releaseSecondaryApp().
const SECONDARY_APP_NAME = 'secondary-account-creation';

const findSecondaryApp = () => getApps().find((a) => a.name === SECONDARY_APP_NAME);

export const getSecondaryAuth = () => {
  const secondaryApp = findSecondaryApp() || initializeApp(firebaseConfig, SECONDARY_APP_NAME);
  return getAuth(secondaryApp);
};

export const releaseSecondaryApp = async () => {
  const existing = findSecondaryApp();
  if (existing) {
    try {
      await deleteApp(existing);
    } catch (e) {
      // ignore
    }
  }
};

export default app;
